<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-4
        div.h6.basic800--text Update personal details
      v-divider.basic300
      v-card-text.pa-4
        v-form(ref="form")
          div.label.basic600--text.text-uppercase Phone Number
          v-text-field.mt-2(background-color="basic200" height="40" v-model="address.phone" placeholder="Enter company phone number" outlined dense hide-details="auto")
          div.mt-4.label.basic600--text.text-uppercase address line 1
          v-text-field.mt-2(background-color="basic200" height="40" v-model="address.address_1" placeholder="e.g. K-3-01, Conzeion, Persiaran IRC" outlined dense :rules="rules.not_empty" hide-details="auto")
          div.mt-4.label.basic600--text.text-uppercase address line 2
          v-text-field.mt-2(background-color="basic200" height="40" v-model="address.address_2" placeholder="e.g. IOI Resort City" outlined dense :rules="rules.not_empty" hide-details="auto")
          div.mt-4.label.basic600--text.text-uppercase postcode
          v-text-field.mt-2(background-color="basic200" height="40" v-model="address.postcode" placeholder="e.g. 62502" outlined dense :rules="rules.not_empty" hide-details="auto" @keyup="fetchPostcodes(address.postcode)")
          div.mt-4.label.basic600--text.text-uppercase city
          v-text-field.mt-2(background-color="basic200" height="40" v-model="address.city" placeholder="e.g. Putrajaya" outlined dense :rules="rules.not_empty" hide-details="auto")
          div.mt-4.label.basic600--text.text-uppercase state
          v-text-field.mt-2(background-color="basic200" height="40" v-model="address.state" placeholder="e.g. Selangor" outlined dense :rules="rules.not_empty" hide-details="auto")
          div.mt-4.label.basic600--text.text-uppercase country
          v-text-field.mt-2(background-color="basic200" height="40" v-model="address.country" placeholder="e.g. Malaysia" outlined dense :rules="rules.not_empty" hide-details="auto")

      v-card-actions.px-2.pb-4.pt-0
        v-spacer
        v-btn(text @click='showModal = false' depressed height=32 )
          .button-Aa-small.primary400--text| Cancel
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading")
          .button-AA-small.basic100--text| Save

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'AddAddressDialog',
  props: ['open', 'propAffiliate'],
  data: () => ({
    isLoading: false,
    address: {},
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    },
  }),
  computed: {
    affiliate: {
      get() {
        return this.propAffiliate
      },
      set(newValue) {
        this.$emit('update:propAffiliate', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
  },
  mounted () {
    if (this.affiliate.address) {
      this.address = { ...this.affiliate.address }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isLoading = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.address.postcode}`).then((response) => {
        const addresses = response.data
        if (this.restrictedCities && this.restrictedCities.length > 0) {
          if (addresses.length > 0 && addresses[0].postcode) {
            if (this.restrictedCities.includes(addresses[0].city)) {
              this.$set(this.address, 'city', addresses[0].city)
              this.$set(this.address, 'state', addresses[0].state)
              this.$set(this.address, 'country', addresses[0].country)
              this.hideFields = false
            } else {
              this.hideFields = true
              this.message = 'Delivery is not available for your address'
            }
          }
        } else {
          this.hideFields = false
          if (addresses.length > 0 && addresses[0].postcode) {
            this.$set(this.address, 'city', addresses[0].city)
            this.$set(this.address, 'state', addresses[0].state)
            this.$set(this.address, 'country', addresses[0].country)
          }
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      // delete this.address.area
      // delete this.address.suburb
      // delete this.address.extra_data
      this.axios.patch(`/partners/${this.affiliate.id}/`, { address: this.address })
        .then(resp => {
          this.showModal = false
          this.affiliate = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>